import { useEffect } from "react";
import NProgress from "nprogress";
import { useNavigate } from "react-router-dom";

type Props = {
    children: JSX.Element;
};

function AuthRoute({ children }: Props): JSX.Element {
    useEffect(() => {
        NProgress.start();
        NProgress.done();
    }, []);

    let navigate = useNavigate();

    useEffect(() => {
        const uidEntity = localStorage.getItem("Uid_Entitie_User");

        if (uidEntity === null) {
            navigate("/login");
        }
    });

    return children;
}

export default AuthRoute;
